import { createContext, useContext, type ReactNode } from "react";

export type RuntimeConfigInput = Readonly<{
  pilotMode: boolean;
  posthogProjectToken?: string | null;
}>;

export type RuntimeConfig = Readonly<{
  pilotMode: boolean;
  posthogProjectToken: string | null;
}>;

export const normalizeRuntimeConfig = (
  input: RuntimeConfigInput,
): RuntimeConfig => {
  const token = input.posthogProjectToken?.trim() ?? "";
  return {
    pilotMode: input.pilotMode,
    posthogProjectToken: token || null,
  };
};

export const runtimeConfig: RuntimeConfig = normalizeRuntimeConfig({
  pilotMode: import.meta.env.VITE_PILOT_MODE === "true",
  posthogProjectToken: import.meta.env.VITE_POSTHOG_PROJECT_TOKEN,
});

const RuntimeConfigContext = createContext<RuntimeConfig | null>(null);

export function RuntimeConfigProvider({
  children,
  value,
}: Readonly<{ children: ReactNode; value: RuntimeConfig }>) {
  return (
    <RuntimeConfigContext.Provider value={value}>
      {children}
    </RuntimeConfigContext.Provider>
  );
}

export const useRuntimeConfig = (): RuntimeConfig => {
  const value = useContext(RuntimeConfigContext);
  if (value === null) {
    throw new Error("RuntimeConfigProvider is missing");
  }
  return value;
};
